import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { CryptoServices } from './CryptoServices';
import { DialogService } from './dialog.service';
import { HTTPService } from './http.service';
import { ConnectionLostBarService } from './ConnectionLostBarService';

@Injectable({
    providedIn: 'root'
  })
export class GlobalErrorHandler extends ErrorHandler {

    static services: DialogService;
    static zoneIn: NgZone;
    static httpIn: HTTPService;
    static crypto: any;
    
    constructor(private zone: NgZone, private dialogService:DialogService, private router:Router, private crypto:CryptoServices, private http:HTTPService,
        private connectionBar:ConnectionLostBarService
    ) {
        super();
        GlobalErrorHandler.services = dialogService;
        GlobalErrorHandler.zoneIn = zone;
        GlobalErrorHandler.httpIn = http;
        GlobalErrorHandler.crypto = crypto;
     }

    handleError(error) {
        // ✅ CORREÇÃO: Silenciar erro _rawValidators no construtor de telas
        // Este erro é um "ruído" que acontece uma única vez quando o usuário clica
        // em um campo no builder-screen, mas não afeta a funcionalidade
        const errorMessage = error?.message || error?.toString() || '';
        if (errorMessage.includes('_rawValidators') ||
            errorMessage.includes("Cannot read properties of null (reading '_rawValidators')")) {
            // Apenas logar no console sem mostrar dialog ao usuário
            console.warn('[GlobalErrorHandler] Erro _rawValidators ignorado (não afeta funcionalidade):', errorMessage);
            return; // Não propagar o erro
        }

        // ✅ CORREÇÃO: Silenciar erro CSS CSSStyleDeclaration indexed setter
        // Browsers Chrome 90+ lançam TypeError ao tentar element.style[0] = value
        // (antes era silencioso). Ocorre na animação/drawer ng-zorro ao abrir o
        // monitor de execução. Não afeta a execução dos fluxos.
        if (errorMessage.includes('CSSStyleDeclaration') ||
            errorMessage.includes('Indexed property setter is not supported')) {
            console.warn('[GlobalErrorHandler] Erro CSS indexed setter ignorado (não afeta funcionalidade):', errorMessage);
            return;
        }

        // ✅ CORREÇÃO: Silenciar erro de ícone SVG não encontrado (MatIconRegistry).
        // Ícones data-driven ([svgIcon]="nome") podem referenciar nomes antigos do Material
        // Icons que não existem no Material Symbols (ex.: setting_cell) — não há SVG a renderizar.
        // O resolver já resolve os nomes válidos em assets/outline/; para os inexistentes o
        // comportamento correto é ícone em branco, sem poluir o console nem abrir dialog ao usuário.
        if (errorMessage.includes('Error retrieving icon')) {
            console.warn('[GlobalErrorHandler] Ícone não encontrado ignorado (renderiza em branco, não afeta funcionalidade):', errorMessage);
            return;
        }

        this.http.handleError(error,false);

        if (GlobalErrorHandler.isConnectionLost(error)) {
            console.log(error)
            this.zone.run(() => this.connectionBar.show());
            super.handleError(error);
            return;
        }

        let status = "0";
        let message = error.message ? error.message : error.toString();


        if ( error instanceof HttpErrorResponse){
            if ( error.status == 401){
                this.router.navigate(['auth'], { skipLocationChange: true });
            }else{
                
                if (  ObjectUtil.isNotEmpty(error.error) ){
                    if ( ObjectUtil.isNotEmpty( error.error.value )){
                        message = JSON.parse(this.crypto.decrypt(error.error.value)).message;
                        status = error.status + " - " +error.statusText;
                    }else{
                        if ( ObjectUtil.isNotEmpty( error.error.message )){
                            message = error.error.message;
                            status = error.status + " - " +error.statusText;
                        }
                    }
                }
            }
        }
        
        this.zone.run(() =>{
            this.dialogService.errorDialoag = true;
            this.dialogService.status = status;
            this.dialogService.openDialog(message);
            this.dialogService.errorDialoag = false;
        });
        
        super.handleError(error);
    }


    public static showError(error){
        this.httpIn.handleError(error,false);
        let message = this.getMessage(error);
        this.zoneIn.run(() =>{
            this.services.errorDialoag = true;
            this.services.status = status;
            this.services.openDialog(message);
            this.services.errorDialoag = false;
        });
    
    }

    public static stopLoadingEvent(){
        this.httpIn.httpEvent = new Event("stopPost");
        if(this.httpIn._observer){
            this.httpIn._observer.next(this.httpIn.httpEvent);   
        }
    }

    public static getMessage(error){
        let message = '';
        if ( error instanceof HttpErrorResponse){
            if ( error.status == 401){
                return "401 - Unauthorized";	
            }else{
                
                if (  ObjectUtil.isNotEmpty(error.error) ){
                    if ( ObjectUtil.isNotEmpty( error.error.value )){
                        message = JSON.parse(this.crypto.decrypt(error.error.value)).message;
                    }else{
                        if ( ObjectUtil.isNotEmpty( error.error.message )){
                            message = error.error.message;
                        }
                    }
                }
            }
        }
        return message;
    }

    public static isConnectionLost(error): boolean {
        return error instanceof HttpErrorResponse && error.status === 0;
    }
 
}
